export const parallaxData = {
  'desktop': {
    '1': {
      'blocks': {
        '1': [-5, 15],
        '2': [-40, 30],
        '3': [-5, 5],
        '4': [-15, 60],
        '5': [-40, 100],
      }
    },
    '2': {
      'blocks': {
        '1': [0, 20],
        '2': [20, 40],
      }
    },
    '3': {
      'blocks': {
        '1': [-20, 10],
        '2': [-40, 20],
      }
    },
    '4': {
      'blocks': {
        '1': [0, 15],
        '2': [-40, 20],
        '3': [0, 5],
        '4': [-10, 40],
        '5': [-40, 100],
      }
    },
  },
  'tablet': {
    '1': {
      'blocks': {
        '1': [-5, 5],
        '2': [-10, 10],
        '3': [-5, 5],
        '4': [-20, 60],
        '5': [-40, 60],
      }
    },
    '2': {
      'blocks': {
        '1': [-10, 10],
        '2': [-20, 15],
      }
    },
    '3': {
      'blocks': {
        '1': [-10, 10],
        '2': [-30, 15],
      }
    },
    '4': {
      'blocks': {
        '1': [-10, 10],
        '2': [-20, 15],
        '3': [-5, 5],
        '4': [-40, 30],
        '5': [-50, 60],
      }
    },
  },
  'mobile': {
    '1': {
      'blocks': {
        '1': [-10, 10],
        '2': [-40, 5],
        '3': [-5, 5],
        '4': [-30, 40],
        '5': [-20, 30],
      }
    },
    '2': {
      'blocks': {
        '1': [-10, 10],
        '2': [-40, 5],
      }
    },
    '3': {
      'blocks': {
        '1': [-10, 10],
        '2': [-40, 5],
      }
    },
    '4': {
      'blocks': {
        '1': [-10, 10],
        '2': [-40, 5],
        '3': [-5, 5],
        '4': [-30, 30],
        '5': [-20, 30],
      }
    },
  },
};

export const getParallaxValue = (type, sectionNumber, blockNumber) => {
  return type ? parallaxData[`${type}`][`${sectionNumber}`]['blocks'][`${blockNumber}`] : [0, 0];
}